import { render } from "./summary_detail_card.vue?vue&type=template&id=2ae56bed"
import script from "./summary_detail_card.vue?vue&type=script&lang=js"
export * from "./summary_detail_card.vue?vue&type=script&lang=js"

import "./summary_detail_card.vue?vue&type=style&index=0&id=2ae56bed&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__